import Vue from 'vue';
import StaffDeviceQRCode from "@/components/staff-device-qrcode/StaffDeviceQRCode.vue";
import Loader from '@/components/loader/Loader.vue';
import WebNotifications from '@/views/staff/web-notifications/WebNotifications.vue';
import { version } from "../package.json";
import { FacilitySettingsModel } from "@/models/FacilitySettings";
import PremiumFeaturesDialog from '@/components/premium/PremiumFeaturesDialog.vue';
import {StaffAccessLevels} from "@/enums/StaffAccessLevels";
import { getAccessLevelDisplayName } from './utils/accessControl/getAccessLevelDisplayName';import { hasAccess } from './utils/accessControl/accessControl';
import { AccessMatrixKeys } from './utils/accessControl/accessMatrixKeysEnum';import { show } from "@intercom/messenger-js-sdk";
import GlobalSessionTimeoutDialog from '@/components/GlobalSessionTimeoutDialog.vue';
import { isAustraliaResHub } from '@/utils/projectConfig';

export default Vue.extend({
    name: 'App',
    components: {
        StaffDeviceQRCode,
        Loader,
        WebNotifications,
        PremiumFeaturesDialog,
        GlobalSessionTimeoutDialog
    },
    data: () => ({
        drawer: null,
        dialog: false,
        tabletQrCode: false,
        loading: false,
        isStoppingImpersonation: false,
        isOpenedResidentsList: false,
        facilitySearchQuery: '',
        attrs: {
            boilerplate: false,
        },
        version: version,
        navigation: {
            width: 280,
            borderSize: 5,
            show: true
        },
        loadingRegirect: false,
        hasAccess,
        AccessMatrixKeys
    }),
    provide() {
        return {
            isSidebarShow: this.navigation
        }
    },
    
    methods: {
        signOut() {
            this.destroyIntercom()
            this.$store.dispatch('userSignOut');
        },
        async changeFacility(id) {
            this.loading = true;
            try {
                this.$store.dispatch('setIsChangingFacilityOnCurrentBrowser', true);
                this.$store.dispatch('setPendingFacilityId', id);
                await this.$store.dispatch('changeCurrentUserFacility', { newFacilityId: id, redirectEnabled: true });
            } finally {
                this.loading = false;
                this.dialog = false;
            }
        },
        openNavItem(route, isEnabled = false) {
            if(!isEnabled){
                this.$refs.premiumFeaturesDialog.open();
            }
            else{
                if (this.$route.path !== route) {
                    this.$router.push(route);
                }
            }
        },
        checkNavItem(facilityAccessProperty) {

             if(facilityAccessProperty === 'isResidents'){
                if(!this.facilitySettingsModel?.featureNonMCareCustomers
                     && !this.facilitySettingsModel?.featureMCareContactsProfiles 
                     && !this.facilitySettingsModel?.featureFamilyEngagement
                     && !this.facilitySettingsModel?.isEnableFamilyCareFeedback){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            } 

            if(facilityAccessProperty === 'isStaffHubCalendar' || facilityAccessProperty === 'featureLifestyle'){
                if(!this.facilitySettingsModel?.isStaffHubCalendar && !this.facilitySettingsModel?.featureLifestyle){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            } 
            
            if(facilityAccessProperty === 'featureFamilyEngagement' || facilityAccessProperty === 'isStaffHubSurveys'){
                if(!this.facilitySettingsModel?.featureFamilyEngagement && !this.facilitySettingsModel?.isStaffHubSurveys){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            } 
            
            if(facilityAccessProperty === 'isStaffHubContentManagerGallery'){
                if(!this.facilitySettingsModel?.isStaffHubContentManagerGallery
                    && !this.facilitySettingsModel?.featureDigitalSignage
                    && !this.facilitySettingsModel?.isStaffHubDevicesColumnDigitalSignage
                    && !this.facilitySettingsModel?.isStaffHubContentManagerMediaLibrary
                    && !this.facilitySettingsModel?.isStaffHubDocuments){
                    this.$refs.premiumFeaturesDialog.open();
                }
                return
            }

            if(!this.facilitySettingsModel[facilityAccessProperty]){
                this.$refs.premiumFeaturesDialog.open();
                return
            }
        },
        toggleSidebar() {
            this.navigation.show = !this.navigation.show;

            if(this.navigation.show) {
                this.navigation.width = 280
            } else {
                this.navigation.width = 25
            }
        },
        showSidebar(data) {
            this.navigation.show = data;

            if(this.navigation.show) {
                this.navigation.width = 280
            } else {
                this.navigation.width = 25
            }
        },
        async stopImpersonation(){
            this.isStoppingImpersonation = true;
            await this.$store.dispatch('stopImpersonation');
            this.isStoppingImpersonation = false;
        },
        async getZendeskJWT() {
            this.loadingRegirect = true;

            await this.$store.dispatch('upsertUser');
            await this.$store.dispatch('getOrg');
            await this.$store.dispatch('mapUserToOrg');
            await this.$store.dispatch('getZendeskRedirectUrl')
            window.open(this.$store.state.zendeskModule.redirectUrl, '_blank', 'noopener, noreferrer');

            this.loadingRegirect = false;
        },
        async intercomShow() {
          if(this.isEnabledIntercom) {
            show();
          }
        },
        destroyIntercom() {
          if(this.isEnabledIntercom) {
            this.$store.dispatch("destroyIntercom");
          }
        }
    },
    computed: {
        
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
        isSuperAdmin() {
            return this.$store.getters.isSuperAdmin;
        },
        isImpersonationMode(){
            return this.$store.getters.isImpersonationMode;
        },
        facilitySettingsModel() {
            const facility: FacilitySettingsModel = this.$store.state.facilityModule.selectedFacility;

            return facility;
        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        }, 
        isExternalPagesViewing() {
            return this.$store.getters.isExternalPagesViewing;
        },
        user() {
            return this.$store.state.authModule.user;
        },
        currentFacility() {
            return this.$store.state.authModule.currentFacility;
        },
        currentFacilityData() {
            return this.$store.state.authModule.currentFacilityData
        },
        isMaintenanceAdmin() {
            return this.user.accessLevel === StaffAccessLevels.MaintenanceAdmin;
        },
        canViewFamilyFeedback() {
            return hasAccess(this.user.accessLevel, AccessMatrixKeys.FamilyFeedback_ViewList);
        },
        accessLevelDisplay(){
            return getAccessLevelDisplayName(this.user.accessLevel)
        },
        isEnabledIntercom() {
          return this.currentFacilityData?.isUsingIntercom;
        },
        isIntercomTokenExpiresAt() {
          return !!this.$store.state.authModule.intercomTokenExpiresAt;
        },
        isAustraliaResHub() {
            return isAustraliaResHub();
        },
        filteredAndSortedFacilities() {
            if (!this.user.facilities) {
                return [];
            }
            
            let sortedFacilities = [...this.user.facilities].sort((a, b) => {
                return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
            });
            
            if (this.facilitySearchQuery && this.facilitySearchQuery.trim()) {
                const searchTerm = this.facilitySearchQuery.trim().toLowerCase();
                sortedFacilities = sortedFacilities.filter(facility => 
                    facility.name.toLowerCase().includes(searchTerm)
                );
            }
            
            return sortedFacilities;
        },
        isSessionTimeoutIdle(){
            return this.$store.state.authModule.sessionTimeoutIsIdle
        }
    },
    inject: {
        theme: {
            default: { isDark: false },
        },
    },
    beforeDestroy() {
        this.destroyIntercom()
    },
    destroyed() {
        this.destroyIntercom();
    }
});